<div *ngIf="project">
  <div>
    <span class="left">{{getProjectName()}}</span>
    <span *ngIf="task.dueDate" class="right"> <i class="material-icons">alarm</i>&nbsp;{{getDate(task)}}</span>
  </div>
  <div class="in-task-mid">
    <h3>{{task.name}}</h3>
  </div>
  <div class="in-task-bottomline">
    <span class="label">
      {{getUserName()}}
    </span>
    <span class="label">
      {{labelToLabel()}}
    </span>
  </div>
</div>
